"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-2 md:gap-16 items-center">
          {}
          <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground leading-tight">
              A Hands-On, Builder-Led Approach
            </h2>
            <p className="text-foreground/80 text-lg leading-relaxed">
              At Brighthouse Construction, the owner-builder is directly involved in every phase of your custom home—from initial design through final completion. This hands-on approach ensures thoughtful decisions, transparent communication, and a calm, confident partnership built on trust. We maintain clean jobsites, prioritize long-term performance over shortcuts, and work closely with serious homeowners who value clarity and quality craftsmanship. Whether it's a timber-frame residence or a full custom build, we bring design-to-completion responsibility and a commitment to building homes that last.
            </p>
          </div>

          {}
          <div ref={imageRef} className={`overflow-hidden rounded-lg transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515703/img/timber_frame_home_construction.png" alt="Custom timber-frame home under construction" className="w-full h-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:scale-[1.01]" />
          </div>
        </div>
      </div>
    </section>;
}